import { useMemo } from "react";
import { useConfirmationPageData } from "./ConfirmationPage/useConfirmationPageData";
import { getCountryCode } from "./QRLanding/utils/countryUtils";
import { ConfirmationPageDO, ConfirmationPageAR, ConfirmationPageDefault } from "./ConfirmationPage/countries";

export function ConfirmationPage() {
  const { employee } = useConfirmationPageData();

  const countryCode = useMemo(() => {
    return getCountryCode(employee?.countryIsoCode);
  }, [employee?.countryIsoCode]);

  // Router por país - fácil de extender agregando más casos
  switch (countryCode) {
    case "DO":
      return <ConfirmationPageDO />;
    case "AR":
      return <ConfirmationPageAR />;
    default:
      return <ConfirmationPageDefault />;
  }
}
